var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersThree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_70_1415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 8.375C15.7278 8.37445 16.4457 8.54364 17.0967 8.86913C17.7477 9.19462 18.3138 9.66743 18.75 10.25",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 10.25C1.68625 9.66743 2.25234 9.19462 2.90331 8.86913C3.55429 8.54364 4.27219 8.37445 5 8.375",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13.375C11.7259 13.375 13.125 11.9759 13.125 10.25C13.125 8.52411 11.7259 7.125 10 7.125C8.27411 7.125 6.875 8.52411 6.875 10.25C6.875 11.9759 8.27411 13.375 10 13.375Z",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625 15.875C6.07366 15.1136 6.71325 14.4825 7.48054 14.0441C8.24784 13.6056 9.11627 13.375 10 13.375C10.8837 13.375 11.7522 13.6056 12.5195 14.0441C13.2867 14.4825 13.9263 15.1136 14.375 15.875",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5781 5.25C12.695 4.79732 12.9365 4.38648 13.2751 4.06414C13.6138 3.74181 14.036 3.5209 14.4939 3.42649C14.9518 3.33209 15.427 3.36798 15.8656 3.53009C16.3041 3.6922 16.6884 3.97403 16.9748 4.34357C17.2612 4.71311 17.4382 5.15556 17.4858 5.62067C17.5333 6.08577 17.4495 6.5549 17.2439 6.97476C17.0382 7.39462 16.7189 7.7484 16.3223 7.99592C15.9256 8.24343 15.4675 8.37476 15 8.375",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99996 8.375C4.53243 8.37476 4.07433 8.24343 3.6777 7.99592C3.28106 7.7484 2.96178 7.39462 2.75611 6.97476C2.55044 6.5549 2.46663 6.08577 2.51419 5.62067C2.56176 5.15556 2.73879 4.71311 3.02518 4.34357C3.31158 3.97403 3.69586 3.6922 4.13439 3.53009C4.57292 3.36798 5.04811 3.33209 5.50601 3.42649C5.96392 3.5209 6.38617 3.74181 6.72482 4.06414C7.06347 4.38648 7.30495 4.79732 7.42184 5.25",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_70_1415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersThree);
export default __webpack_public_path__ + "static/media/UsersThree.d7085db3a3f2432b39e31e07d039259c.svg";
export { ForwardRef as ReactComponent };